import React from "react";
import { Box, Button, Container, Divider, Grid, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { brand, publicNavItems } from "../public.constants";

const PublicFooter = () => (
  <Box component="footer" sx={{ bgcolor: brand.ink, color: "white", mt: 10 }}>
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <Typography variant="h5" fontWeight={950}>
            {brand.name}
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.68)", mt: 1, maxWidth: 420 }}>
            Complete veterinary clinic management platform for appointments, clinical workflows, billing, inventory, and vaccinations.
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.68)", mt: 3 }}>
            Created by{" "}
            <Box component="a" href={brand.companyUrl} target="_blank" rel="noreferrer" sx={{ color: brand.meadow, fontWeight: 900 }}>
              {brand.company}
            </Box>
          </Typography>
        </Grid>

        <Grid item xs={12} md={3}>
          <Typography fontWeight={900} sx={{ mb: 1 }}>Product</Typography>
          <Stack alignItems="flex-start">
            {publicNavItems.map((item) => (
              <Button key={item.path} component={RouterLink} to={item.path} sx={{ color: "rgba(255,255,255,0.74)", px: 0 }}>
                {item.label}
              </Button>
            ))}
          </Stack>
        </Grid>

        <Grid item xs={12} md={2}>
          <Typography fontWeight={900} sx={{ mb: 1 }}>Legal</Typography>
          <Stack alignItems="flex-start">
            <Button component={RouterLink} to="/terms" sx={{ color: "rgba(255,255,255,0.74)", px: 0 }}>Terms</Button>
            <Button component={RouterLink} to="/privacy" sx={{ color: "rgba(255,255,255,0.74)", px: 0 }}>Privacy</Button>
            <Button component={RouterLink} to="/contact" sx={{ color: "rgba(255,255,255,0.74)", px: 0 }}>Contact</Button>
          </Stack>
        </Grid>

        <Grid item xs={12} md={2}>
          <Typography fontWeight={900} sx={{ mb: 1 }}>Access</Typography>
          <Stack alignItems="flex-start">
            <Button component={RouterLink} to="/signin" sx={{ color: "rgba(255,255,255,0.74)", px: 0 }}>Login</Button>
            <Button component={RouterLink} to="/signup" sx={{ color: "rgba(255,255,255,0.74)", px: 0 }}>Signup</Button>
          </Stack>
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.12)", my: 4 }} />
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" spacing={1}>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.62)" }}>
          Copyright © {new Date().getFullYear()} {brand.company}. All rights reserved.
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.62)" }}>
          Built for real veterinary clinics.
        </Typography>
      </Stack>
    </Container>
  </Box>
);

export default PublicFooter;
